/*
 * mod='role'
 * author: nicy
 * time: 2019-02-21
 */

import { smb_fetch, getAgpApiUrl as getApiUrl } from '../../fetch';
import { EventCodeMap, UNKNOWN_EVENT_CODE } from '@/constants/user-behavior';
import md5 from 'crypto-js/md5';

/**
 * 用户行为上报
 * @param {*} data 数据
 * @param {*} useSendBeacon 是否使用navigator.sendBeacon上报，以收集页面关闭时的数据
 * @returns
 */
export const reportUserBehaviorCgi = (data, { useSendBeacon = false } = {}) => {
  // 替换掉特殊的字符/\'
  const replaceCharacter = (params) => {
    return params ? `${params}`.replace(/\'/g, `${escape('\'')}`).replace(/\//g, `${encodeURIComponent('/')}`)
      .replace(/\\/g, escape('\\')) : null;
  };
  const url = getApiUrl('monitor', 'report_behavior');
  const params = $.extend(
    true,
    {
      method: 'POST',
      useSendBeacon,
    },
    {
      ...data,
      data: {
        ...data?.data,
        relation_id: replaceCharacter(data?.data?.relation_id),
        relation_type: replaceCharacter(data?.data?.relation_type),
        relation_name: replaceCharacter(data?.data?.relation_name),
        field1: EventCodeMap[data.data.behavior] || UNKNOWN_EVENT_CODE,
        field2: getUuid() || undefined,
      },
    },
  );
  return smb_fetch(url, params, false);
};

const UUID_STORAGE_NAME = 'CLIENT_UUID';
// 获取设备标识
export function getUuid() {
  try {
    let uuid = localStorage.getItem(UUID_STORAGE_NAME);
    if (!uuid) {
      uuid = md5(`${Date.now()}_${parseInt(Math.random() * 1000000000000, 10)}_abcd_${parseInt(Math.random() * 1000000000000, 10)}`).toString();
      localStorage.setItem(UUID_STORAGE_NAME, uuid);
    }
    return uuid;
  } catch(e) {
    console.error(e);
    return '';
  }
}

/**
 * 获取登录员工的信息
 * @return
 */

export const getAccountInfo = (data) => {
  const url = getApiUrl('auth', 'get_user');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 退出登录
 * @return
 */
export const logout = (data) => {
  const url = getApiUrl('auth', 'logout');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

export const getEduLoginUrl = (data) => {
  const url = getApiUrl('edu', 'get_login_url');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};
